
export default {
  page: {
    background: '#f8f8f8'
  },
  main: {
    color: '#007ACC',
  },
  estimatedDeliveryDateOrStatus: {
    textTransform: 'uppercase',
    fontWeight: '700',
    fontSize: '34px',
    lineHeight: '40px'
  },
  signatureRequired: {
    background: '#95E4FD',
    color: '#222222'
  },
  auctaneBrand: {
    color: '#929292'
  },
  custom1: {  // layout01 card
    border: '1px solid #DFE3E8',
    borderRadius: '2px',
  },
  custom2: {  // layout01 card header
    shadow: ''
  }
};
